import React from 'react';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import ShopPreview from '../components/ShopPreview';
import Services from '../components/Services';


const Home = () => {
    return (
        <>
            <Hero />            
            <ShopPreview />
            <Services />
            <Footer />
        </>

    )
}

export default Home;

